import * as React from 'react';

function Container(name: string, children: React.ReactNode) {
	return <div className='columns medium-6'>
		<label className='socotra-label'>
			{name}<span className='is-red'>*</span>
		</label>
		{children}
	</div>;
}

interface FieldProps {
	name: string;
	value: string;
	onChange(event: React.FormEvent<HTMLTextAreaElement>): void;
}

const ExternalRaterNameOrUrl: React.SFC<FieldProps> = ({
	name,
	value,
	onChange,
}) => {
	return Container(name,
		<textarea
			value={value}
			onChange={onChange}
			data-external-rater-attribute={name}
		/>,
	);
};

export default ExternalRaterNameOrUrl;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/external-service-integrations/modifiable/ExternalRaterNameOrUrl.tsx